import { OrderDto } from './interfaces';

export class OrderCreatedEvent extends Event {
  static readonly event = 'order-created';

  readonly orderNumber: string;

  constructor(orderNumber: string) {
    super(OrderCreatedEvent.event, { bubbles: true });

    this.orderNumber = orderNumber;
  }
}

export class OrderLoadedEvent extends Event {
  static readonly event = 'order-loaded';

  readonly order: OrderDto;

  constructor(order: OrderDto) {
    super(OrderLoadedEvent.event, { bubbles: true });
    this.order = order;
  }
}

declare global {
  interface WindowEventMap {
    [OrderCreatedEvent.event]: OrderCreatedEvent;
    [OrderLoadedEvent.event]: OrderLoadedEvent;
  }
}
